import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { DatePicker } from 'antd';
import moment from 'moment';
import momentPropTypes from 'react-moment-proptypes';
import Button from '../../ui/Button';
import './style.css';

const { RangePicker } = DatePicker;

class DateRangePicker extends PureComponent {
  defaultDates = {
    startDate: moment('2019-09-01'),
    endDate: moment(),
  };

  constructor(props) {
    super(props);

    this.state = {
      show: false,
      dates: [props.startDate, props.endDate],
    };
  }

  validateDateRange = currentDate => currentDate.isAfter(moment());

  handleClickFactory = id => () => {
    const { startDate, endDate } = this.defaultDates;
    const { dates } = this.state;
    const newShow = id === 'btn-range';

    this.setState({
      show: newShow,
      btnActive: id,
      dates: newShow ? dates : [startDate, endDate],
    });

    if (id === 'btn-lifetime') {
      this.props.onDateRangeChange([startDate, endDate]);
    }
  };

  handleChange = dates => {
    this.setState({
      dates,
    });
    this.props.onDateRangeChange(dates);
  };

  renderDuration() {
    const { dates } = this.state;
    const { hideDuration } = this.props;
    const startDate = dates[0];
    const endDate = dates[1];
    const numDays = endDate.diff(startDate, 'days');

    if (hideDuration) return <span />;

    return (
      <div className="rangepicker-display">
        {startDate.format('LL')} -{' '}
        {endDate.diff(moment(), 'days') === 0
          ? 'Present'
          : endDate.format('LL')}
        {numDays > 0 ? ` | ${numDays} days` : null}
      </div>
    );
  }

  render() {
    const { show, dates, btnActive } = this.state;
    return (
      <div>
        {this.renderDuration()}
        <aside className="rangepicker-controls">
          <Button
            className={btnActive === 'btn-lifetime' ? 'btn-active' : null}
            onClick={this.handleClickFactory('btn-lifetime')}
          >
            Lifetime
          </Button>
          <div className="rangepicker-picker">
            <Button
              className={btnActive === 'btn-range' ? 'btn-active' : null}
              onClick={this.handleClickFactory('btn-range')}
            >
              Date Range
            </Button>
            <span style={{ display: show ? 'block' : 'none' }}>
              <RangePicker
                allowClear={false}
                disabledDate={this.validateDateRange}
                value={dates}
                onChange={this.handleChange}
              />
            </span>
          </div>
        </aside>
      </div>
    );
  }
}

DateRangePicker.defaultProps = {
  onDateRangeChange: () => {},
  hideDuration: false,
};

DateRangePicker.propTypes = {
  endDate: momentPropTypes.momentObj.isRequired,
  startDate: momentPropTypes.momentObj.isRequired,
  onDateRangeChange: PropTypes.func,
  hideDuration: PropTypes.bool,
};

export default DateRangePicker;
